import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

export default function AdvRadioGroup({ value, onChange, options, label }) {
    return (
        <Box>
            {label && (
                <Typography
                    sx={{
                        fontSize: 10.5,
                        fontWeight: 700,
                        letterSpacing: '0.07em',
                        textTransform: 'uppercase',
                        color: '#B0B0B0',
                        mt: 1.75,
                        mb: 1,
                    }}
                >
                    {label}
                </Typography>
            )}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                {options.map((opt) => {
                    const selected = value === opt.value;
                    return (
                        <Box
                            key={opt.value}
                            onClick={() => onChange(opt.value)}
                            sx={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: '10px',
                                p: '10px 12px',
                                borderRadius: '10px',
                                border: '1.5px solid',
                                borderColor: selected ? '#00A76F' : '#EBEBEB',
                                backgroundColor: selected ? '#F0FAF6' : '#fff',
                                cursor: 'pointer',
                                userSelect: 'none',
                                transition: 'all 0.12s',
                            }}
                        >
                            <Box
                                sx={{
                                    flexShrink: 0,
                                    mt: '2px',
                                    width: 14,
                                    height: 14,
                                    borderRadius: '50%',
                                    border: '2px solid',
                                    borderColor: selected ? '#00A76F' : '#EBEBEB',
                                    backgroundColor: selected ? '#00A76F' : 'transparent',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.12s',
                                }}
                            >
                                {selected && (
                                    <Box
                                        sx={{
                                            width: 5,
                                            height: 5,
                                            borderRadius: '50%',
                                            backgroundColor: '#fff',
                                        }}
                                    />
                                )}
                            </Box>
                            <Box>
                                <Typography sx={{ fontSize: 12.5, fontWeight: 600, color: '#0D0D0D' }}>
                                    {opt.label}
                                </Typography>
                                {opt.desc && (
                                    <Typography sx={{ fontSize: 11.5, color: '#7A7A7A', mt: '2px', lineHeight: 1.4 }}>
                                        {opt.desc}
                                    </Typography>
                                )}
                            </Box>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
}

AdvRadioGroup.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            desc: PropTypes.string,
        })
    ).isRequired,
    label: PropTypes.string,
};

AdvRadioGroup.defaultProps = {
    label: '',
};
